const PIXEL_ID = '26472237642370868'

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  const w = window as any

  // Preconnect para Google Fonts
  const preconnectFonts = document.createElement('link')
  preconnectFonts.rel = 'preconnect'
  preconnectFonts.href = 'https://fonts.googleapis.com'
  document.head.appendChild(preconnectFonts)

  const preconnectGstatic = document.createElement('link')
  preconnectGstatic.rel = 'preconnect'
  preconnectGstatic.href = 'https://fonts.gstatic.com'
  preconnectGstatic.crossOrigin = 'anonymous'
  document.head.appendChild(preconnectGstatic)

  // Preload hero image
  const preloadHero = document.createElement('link')
  preloadHero.rel = 'preload'
  preloadHero.as = 'image'
  preloadHero.href =
    'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/01_Momento_tranquilo_en_la_tarde.png?v=1775530363'
  document.head.appendChild(preloadHero)

  // Evitar doble inicialización
  if (w.fbq) return

  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Preconnect para rendimiento
  const preconnect = document.createElement('link')
  preconnect.rel = 'preconnect'
  preconnect.href = 'https://connect.facebook.net'
  document.head.appendChild(preconnect)

  // Inicializar pixel
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')

  // Noscript fallback
  const noscriptImg = document.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscriptImg)
}

export const trackViewContent = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'ViewContent', {
      content_name: 'Guia Cero Atrasos 21 Dias',
      content_category: 'Educacion Financiera',
      content_ids: ['cero-atrasos-01'],
      content_type: 'product',
      value: 14.97,
      currency: 'USD',
    })
  }
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', {
      value: 14.0,
      currency: 'USD',
      content_name: 'Guia Cero Atrasos 21 Dias',
      content_ids: ['cero-atrasos-01'],
      content_type: 'product',
    })
    console.log('✅ Evento AddToCart enviado a Meta')
  }
}

export const trackInitiateCheckout = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout', {
      value: 14.0,
      currency: 'USD',
      content_name: 'Guia Cero Atrasos 21 Dias',
      content_ids: ['cero-atrasos-01'],
      content_type: 'product',
    })
    console.log('✅ Evento InitiateCheckout enviado a Meta')
  }
}

export const trackPurchase = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'Purchase', {
      value: 14.0,
      currency: 'USD',
      content_name: 'Guia Cero Atrasos 21 Dias',
      content_ids: ['cero-atrasos-01'],
      content_type: 'product',
    })
    console.log('✅ Evento Purchase enviado a Meta')
  }
}
